import { TextMaterialTheme } from '@@partner:types:app'
import { CommonPager, CommonSort, NestedFilter, PageInfo } from '@@partner:types:graphql'
import { gql, useQuery } from '@apollo/client'
import { SHORTCUT_TEXT_MATERIAL_THEME_FIELDS } from '../textMaterialShortcut'
import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'


export interface AllTextMaterialThemes {
  allTextMaterialThemes: {
    edges: TextMaterialTheme[]
    pageInfo: PageInfo
  }
}

export interface AllTextMaterialThemesVariables {
  filter?: NestedFilter
  pager: CommonPager
  sort: CommonSort
}

export const GQL_QUERY_ALL_TEXT_MATERIAL_THEMES = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allTextMaterialThemes(
      filter: $filter
      pager: $pager
      sort: $sort
    ) {
      edges {
        ${SHORTCUT_TEXT_MATERIAL_THEME_FIELDS}
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllTextMaterialThemes = (variables: AllTextMaterialThemesVariables) =>
  useQuery<AllTextMaterialThemes, AllTextMaterialThemesVariables>(
    GQL_QUERY_ALL_TEXT_MATERIAL_THEMES,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )